import { render, staticRenderFns } from "./ButtonBlock.vue?vue&type=template&id=cac55f0a"
import script from "./ButtonBlock.vue?vue&type=script&lang=js"
export * from "./ButtonBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports